import styled from 'styled-components';

const Title = styled.h1`
    color: ${(props) => props.theme.primaryText};
    width: ${(props) => props.width || '100%'};
    height: ${(props) => props.height};
    text-align: center;
    background: ${(props) => props.theme.primary};
    padding: 18px 0;
    margin: 0;
    letter-spacing: 0.1em;
    font-weight: bold;

    @media (max-width: 700px) {
        font-size: 2em;
    }
`;

const TitleContainer = styled.div`
    background-color: ${(props) => props.theme.primary};
    border-radius: 0px;
    color: white;
    display: grid;
    align-items: center;
    flex-flow: column;
    font-weight: 400;
    padding: 10px;
    height: 10em;
`;

export { Title, TitleContainer };
